// src/components/sepa/SepaSummaryBar.jsx
import React from "react";
import PropTypes from "prop-types";
import {
  Box,
  Button,
  Chip,
  Stack,
  Tooltip,
  FormControlLabel,
  Checkbox,
} from "@mui/material";

export default function SepaSummaryBar({
  rowsCount,
  totalAmount,
  canGenerate,
  markPaid,
  onToggleMarkPaid,
  onGenerate,
}) {
  return (
    <Box
      sx={{
        mt: 2,
        display: "flex",
        alignItems: "center",
        gap: 2,
        flexWrap: "wrap",
      }}
    >
      <Stack direction="row" spacing={1} alignItems="center">
        <Chip label={`Vorgänge: ${rowsCount}`} />
        <Chip
          label={`Gesamt: ${new Intl.NumberFormat("de-DE", {
            style: "currency",
            currency: "EUR",
          }).format(totalAmount)}`}
          sx={{ fontSize: 18 }}
          color="secondary"
        />
      </Stack>

      <FormControlLabel
        control={
          <Checkbox
            checked={markPaid}
            onChange={(e) => onToggleMarkPaid(e.target.checked)}
          />
        }
        label="Mitglieder als bezahlt markieren"
      />

      <Tooltip title="SEPA-XML (pain.008) erzeugen und herunterladen">
        <span>
          <Button
            variant="contained"
            color="secondary"
            disabled={!canGenerate}
            onClick={onGenerate}
          >
            SEPA-Datei erzeugen
          </Button>
        </span>
      </Tooltip>
    </Box>
  );
}

SepaSummaryBar.propTypes = {
  rowsCount: PropTypes.number.isRequired,
  totalAmount: PropTypes.number.isRequired,
  canGenerate: PropTypes.bool.isRequired,
  markPaid: PropTypes.bool.isRequired,
  onToggleMarkPaid: PropTypes.func.isRequired,
  onGenerate: PropTypes.func.isRequired,
};
